export const environment = {
  production: false,
  // apiBaseUrl: 'https://app.grintafy.com/', // old
  // apiBaseUrl: 'https://livenode.grintafy.com/', // old

  apiBaseUrl: 'https://dev-app.grintafy.com/', //  Test Server
  // apiBaseUrl: 'https://02e3-125-20-102-34.ngrok-free.app/',//localhost test server

  //apiBaseUrl: 'https://livenodev2.grintafy.com/', // Live Serverss 

  //apiBaseUrl: 'http://54.70.18.204:8000/' --old
};



